import { Modal, Button } from "antd";
import styled from "styled-components";
import { showSuccess, showError } from "infra/helpers/alerta";
import { useDeletePlanejamento } from "../../hooks/useDeletePlanejamento";
import useModal from "../../hooks/useModal";

interface DeleteModalProps {
  refetch: () => void;
  refetchMap: () => void;
}

function DeleteModal({ refetch, refetchMap }: DeleteModalProps) {

  const { mutateAsync, isLoading } = useDeletePlanejamento();
  const { idDelete, ids, isDeletingMultiple, names, setIdDelete, setIds, setNames, isDeleting, setIsDeleting } = useModal();

  async function handleDelete() {

    try {
      if(!idDelete && !isDeletingMultiple) return;
      let response: any;
      if(isDeletingMultiple) {
        ids?.forEach(async (idPromisse) => {
          response = await mutateAsync(idPromisse);
        });
      } else {
        response = await mutateAsync(idDelete!);
      }

      if (response.status === 204) {
        showSuccess("Plano operacional deletado com sucesso!");
        closedModal();
        refetch();
        refetchMap();
        return;
      }
      const details = (response as any).response.data.Details;
      const error = details[0].Errors[0];
      showError(error);
      closedModal();
    } catch (error) {
      showError('Não foi possivel deletar o plano operacional');
      closedModal();
    }
  }

  function closedModal() {
    setIsDeleting(false);
    setIdDelete('');
    setIds([]);
    setNames([]);
  }

  return (
    <CustomModal
      title="Excluir Planejamento Operacional"
      visible={isDeleting}
      onCancel={closedModal}
      maskClosable={false}
      className="teste"
      footer={
        <>
          <Button
            size="large"
            loading={isLoading}
            onClick={closedModal}
            style={{ borderRadius: 8 }}
          >Cancelar</Button>
          <Button
            size="large"
            type="primary"
            danger
            loading={isLoading}
            onClick={handleDelete}
            style={{ borderRadius: 8 }}
          >Confirmar</Button>
        </>
      }
    >
      <p>Tem certeza que deseja excluir o planejamento operacional {names?.join(', ')}?</p>
    </CustomModal>
  );
}

const CustomModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-modal-header {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #ff4d4f;
  }

  .ant-modal-title {
    color: #fff;
    font-weight: bold;
  }

  .ant-modal-close-x {
    color: #fff;
  }
`;

export default DeleteModal;
